import { usePathname } from 'next/navigation'

export const useBasePath = () => {
  const pathName = usePathname()
  return pathName.substring(0, pathName.lastIndexOf('/'))
}

export default useBasePath
